/**
 * CUSTOMER-R4.7-A — customer may edit delivery only before fulfilment lock.
 */
export type DeliveryEditEligibility = {
  canEdit: boolean;
  reason: "ok" | "cancelled" | "paid_locked" | "fulfillment_locked" | "ttn_locked";
};

const CANCELLED = new Set(["canceled", "cancelled"]);
const FULFILLMENT_LOCKED = new Set([
  "accepted",
  "packing",
  "ready_to_ship",
  "shipped",
  "completed",
  "delivered",
  "received",
  "collected",
]);

export function resolveCustomerDeliveryEditEligibility(input: {
  orderTopStatus?: string | null;
  status?: string | null;
  paymentStatus?: string | null;
  ttn?: string | null;
  packingOrShipmentStarted?: boolean;
}): DeliveryEditEligibility {
  const top = String(input.orderTopStatus ?? input.status ?? "")
    .trim()
    .toLowerCase();
  const pay = String(input.paymentStatus ?? "")
    .trim()
    .toLowerCase();
  const ttn = String(input.ttn ?? "")
    .trim()
    .toLowerCase();

  if (CANCELLED.has(top)) return { canEdit: false, reason: "cancelled" };
  if (ttn && ttn !== "none" && ttn !== "not_set" && ttn !== "pending") {
    return { canEdit: false, reason: "ttn_locked" };
  }
  if (input.packingOrShipmentStarted || FULFILLMENT_LOCKED.has(top)) {
    return { canEdit: false, reason: "fulfillment_locked" };
  }
  // Paid orders: allow delivery edit only while still pre-fulfilment (unpaid path is primary).
  if (
    pay.includes("paid") ||
    pay === "payment_confirmed_bank_iban" ||
    pay === "refund_pending"
  ) {
    // Still pre-accept unpaid-like edit window for unpaid; paid needs manager unless still "new".
    if (top && top !== "new" && top !== "created" && top !== "pending" && top !== "") {
      return { canEdit: false, reason: "paid_locked" };
    }
  }
  return { canEdit: true, reason: "ok" };
}
